import React from "react";
import {useSearchParams} from "react-router-dom";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import LinkStyled from "shared/ui/LinkStyled";
import ChangePasswordForm from "../components/ChangePasswordForm";
import ForgotPasswordForm from "../components/ForgotPasswordForm";
import AuthCardLayout from "../components/AuthCardLayout";

const ForgotPassword = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    return (
        <Grid container spacing={4} justifyContent="center">
            <AuthCardLayout image="/images/account-type-1.svg" title="Brio în școli" size="large" showBackButton={true}>
                <Typography variant="h2" sx={{marginBottom: 2}}>Resetează parola</Typography>
                {token ? <ChangePasswordForm type="school"/> : <ForgotPasswordForm type="school"/>}
                <LinkStyled to="/login/scoala">Autentificare</LinkStyled>
            </AuthCardLayout>
        </Grid>
    );
};

export default ForgotPassword;
